var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiPoweredSolutuon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFD6F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#F189DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 19.2955C12.4425 18.8541 11.8384 18.5114 11.1879 18.2675C10.5374 18.0235 9.86368 17.9016 9.16671 17.9016C8.67883 17.9016 8.19966 17.9654 7.72921 18.0932C7.25875 18.221 6.80863 18.4011 6.37883 18.6334C6.13489 18.7612 5.89966 18.7553 5.67315 18.616C5.44663 18.4766 5.33337 18.2733 5.33337 18.0061V9.60762C5.33337 9.47984 5.36532 9.35787 5.42921 9.24171C5.4931 9.12555 5.58893 9.03843 5.71671 8.98035C6.25105 8.70156 6.80863 8.49247 7.38943 8.35307C7.97024 8.21368 8.56267 8.14398 9.16671 8.14398C9.84044 8.14398 10.4997 8.2311 11.1444 8.40535C11.7891 8.57959 12.4076 8.84095 13 9.18944V17.6228C13.5925 17.2511 14.2139 16.9723 14.8644 16.7864C15.5149 16.6005 16.1713 16.5076 16.8334 16.5076C17.2516 16.5076 17.661 16.5425 18.0618 16.6122C18.4625 16.6819 18.8662 16.7864 19.2728 16.9258V8.56217C19.447 8.62025 19.6183 8.68123 19.7868 8.74512C19.9552 8.80901 20.1207 8.88742 20.2834 8.98035C20.4112 9.03843 20.507 9.12555 20.5709 9.24171C20.6348 9.35787 20.6667 9.47984 20.6667 9.60762V18.0061C20.6667 18.2733 20.5534 18.4766 20.3269 18.616C20.1004 18.7553 19.8652 18.7612 19.6213 18.6334C19.1915 18.4011 18.7413 18.221 18.2709 18.0932C17.8004 17.9654 17.3213 17.9016 16.8334 17.9016C16.1364 17.9016 15.4627 18.0235 14.8122 18.2675C14.1617 18.5114 13.5576 18.8541 13 19.2955ZM14.394 15.8106V9.18944L17.8788 5.70459V12.6743L14.394 15.8106ZM11.6061 16.9432V10.0432C11.2228 9.8806 10.8249 9.75573 10.4125 9.6686C10.0002 9.58148 9.58489 9.53792 9.16671 9.53792C8.73691 9.53792 8.31873 9.57858 7.91216 9.65989C7.5056 9.74121 7.11065 9.86318 6.72731 10.0258V16.9432C7.13388 16.7922 7.53754 16.6819 7.9383 16.6122C8.33906 16.5425 8.74853 16.5076 9.16671 16.5076C9.58489 16.5076 9.99436 16.5425 10.3951 16.6122C10.7959 16.6819 11.1995 16.7922 11.6061 16.9432Z",
    fill: "#8C3880"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPoweredSolutuon);
export default __webpack_public_path__ + "static/media/AiPoweredSolutuon.0914efa354fa907f972cff67b854d778.svg";
export { ForwardRef as ReactComponent };